var map = {
	"./dark.scss": [
		"./src/assets/sass/themes/layout/brand/dark.scss",
		38
	],
	"./light.scss": [
		"./src/assets/sass/themes/layout/brand/light.scss",
		39
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/sass/themes/layout/brand lazy recursive ^\\.\\/.*\\.scss$";
module.exports = webpackAsyncContext;